"use client";

import createSvgIcon from "./utils/createSvgIcon.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default createSvgIcon([/*#__PURE__*/_jsx("path", {
  d: "M12 7.77 5.61 18h12.78z",
  opacity: ".3"
}, "0"), /*#__PURE__*/_jsx("path", {
  d: "M12 4 2 20h20zm0 3.77L18.39 18H5.61z"
}, "1")], 'ChangeHistoryTwoTone');